
export const config = {
    BASE_URL: window.location.origin,
    //API_BASE_URL: `${window.location.protocol}//${window.location.hostname}:3020/api`,
    API_BASE_URL: `/api`,
};
